import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import undoRedo from "undo-redo-vuex";
import authModule from "@dpa-connect/dpa-id-user/store/modules/auth";
import newsItems from "./modules/newsItems";
import filters from "./modules/filters";
import filterRules from "./modules/filterRules";
import ui from "./modules/ui";
import user from "./modules/user";
import settings from "./modules/settings";
import stageconfig from "./modules/stageconfig";
import conceptItems from "./modules/conceptItems";
import collaboration from "./modules/collaboration";
import language from "./language";
import API_SETTINGS from "../constants/apiSettings";

const auth = authModule(API_SETTINGS);

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

/*
 * NB: Rehydrates created date from local storage.
 */

function getState(key, storage) {
  let result;

  try {
    const item = storage.getItem(key);
    if (item !== null) {
      result = JSON.parse(item);
    }
  } catch (err) {
    console.log(err); // eslint-disable-line no-console
  }

  return result;
}

const cookieEnabled = navigator && navigator.cookieEnabled;
const persistedState = cookieEnabled
  ? [
      createPersistedState({
        paths: ["filters", "settings"],
        getState
      })
    ]
  : [];

export default new Vuex.Store({
  plugins: [
    ...persistedState,
    undoRedo({
      paths: [
        {
          namespace: "filters",
          ignoreMutations: [
            "setErrorStatus",
            "setFilterIsVisible",
            "setIsLoadingStatus",
            "setLoadedStatus"
          ]
        }
      ]
    })
  ],
  modules: {
    newsItems,
    filters,
    filterRules,
    ui,
    auth,
    user,
    settings,
    stageconfig,
    conceptItems,
    collaboration,
    language
  },
  strict: debug
});
